// extracted by mini-css-extract-plugin
module.exports = {"customBtnStyles":"FlashCardDeck_customBtnStyles__TLCxD"};